import styled from 'styled-components';
import {desktopMedia} from '../../../../../../globalVariables/GlobalVariables';

export const currency = styled.span`
    font-size: inherit;
    margin-inline-end: var(--space-2xs);
    ${desktopMedia}{
        font-size: var(--font-size-caption);
    }
`;
